<script>
export default {
  name: 'ReportFiltersStatus',
  emits: ['statusFilterSelection'],
  data() {
    return {
      selectedOption: null,
      options: [
        {
          value: null,
          label: this.$t('REPORT.FILTERS.STATUS.ALL'),
        },
        {
          value: 'open',
          label: this.$t('REPORT.FILTERS.STATUS.OPEN'),
        },
        {
          value: 'resolved',
          label: this.$t('REPORT.FILTERS.STATUS.RESOLVED'),
        },
        {
          value: 'pending',
          label: this.$t('REPORT.FILTERS.STATUS.PENDING'),
        },
        {
          value: 'snoozed',
          label: this.$t('REPORT.FILTERS.STATUS.SNOOZED'),
        },
      ],
    };
  },
  methods: {
    handleInput(selectedStatus) {
      this.$emit('statusFilterSelection', selectedStatus);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :option-height="24"
      :placeholder="$t('REPORT.FILTERS.STATUS.PLACEHOLDER')"
      :options="options"
      :show-labels="false"
      track-by="value"
      label="label"
      @update:model-value="handleInput"
    />
  </div>
</template>
